import ArcUUID from '~/util/arc-identifiers'
import angular from 'angular'
import * as _ from 'lodash'

export default ['$interval', beatsService]

const DELAY = 500
function beatsService($interval) {
  this.funkyBeats = {}
  this.removeFunkyBeat = function removeFunkyBeat(identity) {
    let funkyBeat = _.get(this.funkyBeats, identity)
    if (angular.isDefined(funkyBeat)) {
      $interval.cancel(this.funkyBeats[identity])
    }
  }.bind(this)
  this.addFunkyBeat = function addFunkyBeat(funkyBeat) {
    let identity = ArcUUID.create()
    this.funkyBeats[identity] = $interval(funkyBeat, DELAY)
    return function clearAFunkyBeat() {
      this.removeFunkyBeat(identity)
    }.bind(this)
  }.bind(this)
}
